export const status = [
  {
    display: "Active",
    value: true
  },
  {
    display: "Not Active",
    value: false
  }
]